import { EllipsisVertical } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

type ApplicationDropdownProps = {
  isPinned?: boolean;
  applicationId: string;
  isDepartmentView?: boolean;
  onTogglePin?: (id: string) => void;
};

export const ApplicationDropdown = ({
  isPinned,
  applicationId,
  isDepartmentView = false,
  onTogglePin,
}: ApplicationDropdownProps) => {
  const handlePinClick = () => {
    if (onTogglePin && applicationId !== undefined) {
      onTogglePin(applicationId);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="mx-auto flex h-6 w-6 cursor-pointer items-center justify-center rounded-md hover:bg-slate-100">
          <EllipsisVertical className="text-slate-700" size={16} />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {!isDepartmentView && (
          <DropdownMenuItem onSelect={handlePinClick}>{isPinned ? "Unpin" : "Pin"}</DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
